import { FingerprintHistory } from './fingerprintHistory';
import { PreBillState } from './preBill';

export enum PreBillFingerprintType {
  Created = 'preBillCreated',
  CargosUpdated = 'preBillCargosUpdated',
  CargoRemoved = 'preBillCargoRemoved',
  Emptied = 'preBillEmptied',
  ValidationChanged = 'preBillValidationChanged',
  Billed = 'preBillBilled'
}

export interface PreBillFingerprintData {
  description?: string;
  preBillConsecutive?: number;
  totalCargos?: number;
  addedConsecutives?: number[];
  removedConsecutives?: number[];
  cargoConsecutive?: number;
  reason?: string;
  reasonDescription?: string;
  validated?: boolean;
  previousState?: PreBillState | string;
  newState?: PreBillState | string;
}

export interface PreBillFingerprintHistory extends FingerprintHistory {
  fingerprintType?: PreBillFingerprintType | string;
  data?: PreBillFingerprintData;
}
